<template>
  <NuxtLink
    v-bind="$attrs"
    class="text-eo-primary-500 sm:hover:underline"
  >
    <slot />
  </NuxtLink>
</template>
